/** Version de l'interface chargée, fixée à la construction (`OASIS_VERSION`, vite.config.ts). */
declare const __OASIS_VERSION_INTERFACE__: string | undefined;

export const VERSION_INTERFACE: string =
  typeof __OASIS_VERSION_INTERFACE__ === 'string' ? __OASIS_VERSION_INTERFACE__ : 'dev';
